module.exports = __webpack_public_path__ + "static/media/shadow.8d0f9ebe.svg";